import { render, staticRenderFns } from "./VuetifyStatepicker.vue?vue&type=template&id=1554b342&scoped=true&"
import script from "./VuetifyStatepicker.vue?vue&type=script&lang=js&"
export * from "./VuetifyStatepicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1554b342",
  null
  
)

export default component.exports